import { compose } from 'ramda';
import React, { useEffect } from 'react';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component';
import { Loader } from 'js/components/common/Loader';

import { withDynamicReducer, useDynamicReducerSelector } from './store';
import { handleVerifyClick } from './helpers';
import * as hooks from './hooks';
import { JUMIO, ICON_TYPE_TO_STATUS_MAP } from './constants';

import style from './Jumio.scss';

export const JumioBare = () => {
    const t = useComponentTranslations();
    const { uploadRequirement, haveCopyIDFax } = useDynamicReducerSelector();
    const getPlayerData = hooks.useGetPlayerData();
    const getPlayerTag = hooks.useGetPlayerTag({ t });
    const verificationStatus = hooks.useVerificationStatus({ uploadRequirement, haveCopyIDFax });

    useEffect(() => {
        getPlayerData();
        getPlayerTag();
    }, [
        getPlayerData,
        getPlayerTag
    ]);

    if (!uploadRequirement || !haveCopyIDFax) {
        return <Loader />;
    }

    return (
        <div className={`${style.container} jumio-status-${verificationStatus}`}>
            <h3 className={style.title}>{t('title')}</h3>
            <p className={style.description}>{t('description')}</p>
            <div>
                <Icon type={ICON_TYPE_TO_STATUS_MAP[verificationStatus]} />
                <span>{t(`status.${verificationStatus}`)}</span>
            </div>
            <Button className={`${style.button} jumio-verify-btn`} onClick={handleVerifyClick}>
                {t('button')}
            </Button>
        </div>
    );
};

export const Jumio = compose(
    withComponent({ isForLoggedIn: true }),
    withDynamicReducer()
)(JumioBare);

componentService.registerPageComponents({ [JUMIO]: Jumio });
